import {Component, Inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {AssetTypesFilters} from "./asset-types-filter.interface";

@Component({
  selector: 'app-asset-types-filter',
  templateUrl: './asset-types-filter.component.html',
  styleUrls: ['./asset-types-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AssetTypesFilterComponent implements OnInit {

  filters: AssetTypesFilters = {
    archived: 'false',
    on_parent_list: true
  } as AssetTypesFilters;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AssetTypesFilterComponent>
  ) { }

  ngOnInit() {
    this.filters.archived = this.data['filter_archived'] ?? 'false';
    this.filters.on_parent_list = this.data['filter_on_parent_list'] ?? true;
  }

  /**
   * Clears the filters and closes the form.
   *
   * @return {void}
   */
  onClearAndClose(): void {
    this.filters.archived = 'false';

    this.onSaveAndClose();
  }

  /**
   * Saves the filters and closes the dialog.
   *
   * @return {void}
   */
  onSaveAndClose(): void {
    let response: any;

    response = {
      archived: this.filters.archived
    }

    this.dialogRef.close(response);
  }

}
